<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';

export default {
  inject: ['setLoading'],
  data() {
    return {
      id: '',
      ids: [],
      errors: {},
      currency: '',
      loading: false,
      app_currency: '',
      party_type: '',
      party_id: '',
      parties: [],
      party: '',
      name: '',
      email: '',
      contact: '',
      amount: '',
      description: '',
      data: []
    };
  },

 async mounted(){ 
  this.app_currency = await this.$appCurrency();
 },

 methods: {   
  
  add(){
   this.resetForm();
   this.party_type = `App\\Models\\Lead`;
  },

  detail(row){
   this.setLoading(true);
   try{
    this.data = row;
   }finally{
    this.setLoading(false);
   } 
  },
    
  createViaParty(party_type, party_id){
   this.add(); 
   this.party_type = party_type;
   this.getPartyById(party_type, party_id);
  },

  async getPartyById(party_type, id){
   try{
    let res;
    if(party_type === `App\\Models\\Lead`){
     res = await axios.get(`/leads/${id}`);
    }else{
     res = await axios.get(`/customers/${id}`);
    }
    this.party = res.data.data;
    this.onPartySelected(this.party);
   }catch(error){
    this.$swalToast("Party not found", 'error');
   }
  },

  async onSearch(search){
   if(!search || search.length < 2) return;
   this.loading = true;
   try{
    let res;
    if(this.party_type === "App\\Models\\Lead"){
     res = await axios.get('/leads/dropdown', { params: { search_keyword: search } });
    }else if(this.party_type === "App\\Models\\Customer") {
     res = await axios.get('/customers/dropdown', { params: { search_keyword: search } });
    }
    this.parties = res.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.loading = false;
   }
  },

  onPartySelected(party){
   this.name = party?.name || '';
   this.email = party?.email || '';
   this.contact = party?.mobile || '';
  },

  async createPaymentLink(){
   this.errors = {};
   this.setLoading(true);
   try{
    const payload = {
     party_id: this.party?.id,
     party_type: this.party_type,
     name: this.name,
     email: this.email,
     contact: this.contact,
     amount: this.amount,
     currency: this.party?.currency?.code || this.app_currency?.code,
     description: this.description,  
    }; 
    
    const response = await axios.post(`/payments/payment-links/create`, payload);
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.closeModal('payment_link_modal');

    Swal.fire({
     title: 'Payment Link Created',
     html: `
      <div style="text-align: left;">
       <p>Payment Link:</p>
       <div style="display: flex; gap: 10px; align-items: center;">
        <input type="text" id="paymentLink" value="${response.data.data.short_url}" readonly style="flex: 1; padding: 8px 12px; font-size: 14px; border: 1px solid #ddd; border-radius: 4px;" />
        <button id="copyBtn" style="padding: 8px 16px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;">Copy URL</button>
        </div>
      </div>`,
     showConfirmButton: false,
     allowOutsideClick: true,
     didOpen: () => {
      document.getElementById('copyBtn').addEventListener('click', () => {
       this.$copyText(document.getElementById('paymentLink').value);
      });
     }
    });

   }catch(error){
    if(error.type === 'validation'){
     this.errors = error.errors;   
    }else{
     this.$swalToast(error.message, 'error');
    }
   }finally{
    this.setLoading(false);
   } 
  },

  async deletePaymentLink(){
   this.setLoading(true);
   try{
    const response = await axios.delete(`/payments/payment-links/${this.data?.id}/delete`);
    this.$swalToast(response.data.message);
    this.$emit('updated'); 
    this.closeModal('payment_link_delete_modal');
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.name = '';
   this.email = '';
   this.contact = '';
   this.party = '';
   this.party_id = '';
   this.party_type = '';
   this.amount = '';
   this.description = '';
   this.errors = {}; 
  }

 }
};
</script>

<template>
<!-- PAYMENT LINK MODAL -->
<div class="modal fade" id="payment_link_modal">
<div class="modal-dialog modal-dialog-centered modal-lg w-100">
<div class="modal-content">
<div class="modal-header">
 <h4 class="modal-title">Create Payment Link</h4>
  <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
  <i class="ti ti-x"></i>
  </button>
</div>

 <form @submit.prevent="createPaymentLink">
  <div class="modal-body">
    
    <div class="row">
     <div class="col-md-6">
      
      <div class="card">
       <div class="card-header"> <h6>Client Details</h6> </div>
        <div class="card-body">
        
       <div class="row">
        <div class="col-md-5">
         <div class="mb-3">
        <label class="form-label">Client Type <span class="text-danger"> *</span></label>
        <select class="form-control" v-model="party_type">
        <option value="">Choose any</option>
        <option value="App\Models\Lead" :selected="party_type === `App\\Models\\Lead`">Lead</option>
        <option value="App\Models\Customer" :selected="party_type === `App\\Models\\Customer`">Customer</option>
        </select>
        <div v-if="errors.party_type" class="text-danger small mt-1">{{ errors.party_type[0] }}</div>
        </div>
        </div>
        <div class="col-md-7">
          <div class="mb-3" v-if="party_type === `App\\Models\\Lead` || party_type === `App\\Models\\Customer`">
        <label class="form-label">Client <span class="text-danger"> *</span></label>
        <vue-select v-model="party" :options="parties" :loading="loading" :filterable="false" @search="onSearch" @update:modelValue="onPartySelected" label="name" :placeholder="party_type === `App\\Models\\Lead` ? 'Search and select a lead' : 'Search and select a customer'"/>
        <div v-if="errors.party_id" class="text-danger small mt-1">{{ errors.party_id[0] }}</div> 
        </div>
        </div> 
       </div>     
        
       <div class="row"> 
        <div class="col-md-6">
         <div class="mb-3">
        <label class="form-label">Name <span class="text-danger"> *</span></label>
        <input type="text" class="form-control" v-model="name" />
        <div class="text-danger small mt-1" v-if="errors.name">{{ errors.name[0] }}</div>
        </div>
        </div>
        <div class="col-md-6">
         <div class="mb-3">
        <label class="form-label">Contact No <span class="text-danger"> *</span></label>
        <input type="text" class="form-control" v-model="contact" />
        <div class="text-danger small mt-1" v-if="errors.contact">{{ errors.contact[0] }}</div> 
        </div>
        </div>
       </div> 

        <div class="mb-3">
        <label class="form-label">Email <span class="text-danger"> *</span></label>
        <input type="text" class="form-control" v-model="email" />
        <div class="text-danger small mt-1" v-if="errors.email">{{ errors.email[0] }}</div>
        </div>   
 
       </div>
      </div>

     </div>
     <div class="col-md-6">
      
      <div class="card">
       <div class="card-header"> <h6>Payment Details</h6> </div>
        <div class="card-body">

        <div class="mb-3">
        <label class="form-label">Amount <span class="text-danger"> *</span></label>
        <input type="number" class="form-control" v-model="amount" />
        <div class="text-danger small mt-1" v-if="errors.amount">{{ errors.amount[0] }}</div>
        </div>   

        <div class="mb-3">
        <label class="form-label">Description <span class="text-danger"> *</span></label>
        <textarea type="text" class="form-control" v-model="description"></textarea>
        <div class="text-danger small mt-1" v-if="errors.description">{{ errors.description[0] }}</div>
        </div>   
 
       </div>
      </div>

     </div>   
    </div>

    
  </div> 
    
  <div class="modal-footer">
   <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal">Cancel</button>
   <button type="submit" class="btn btn-primary">Create</button>
  </div>
 </form>

  </div>
 </div>
</div>

<!-- View Details -->
<div class="modal fade" id="payment_link_view_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-header bg-dark">
<h4 class="modal-title text-white">Payment Link Details</h4>
<button type="button" class="btn-close custom-btn-close bg-transparent fs-16 text-white position-static" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
</div>
<div class="modal-body">

<!-- Card 1: Payment Details -->
<div class="card mb-3">
  <div class="card-header bg-light d-flex justify-content-between align-items-center">
    <h6 class="card-title mb-0"><i class="ti ti-credit-card me-2"></i>Payment Details</h6>
    <span :class="{'badge' : true, 'text-capitalize' : true, 'bg-success' : data.status === 'paid', 'bg-danger' : data.status === 'unpaid'}">{{ data.status }}</span>
  </div>
  <div class="card-body">
    <div class="row row-gap-3 text-center">
      <div class="col-md-4">
        <span class="d-block mb-1 fw-bold">Gateway ID</span>
        <p class="text-dark fw-normal mb-0">{{ data.gateway_payment_link_id }}</p>
      </div>
      <div class="col-md-5">
        <span class="d-block mb-1 fw-bold">Transaction ID</span>
        <p class="text-dark fw-normal mb-0">{{ data.transaction_id }}</p>
      </div>
      <div class="col-md-3">
        <span class="d-block mb-1 fw-bold">Amount</span>
        <span class="badge bg-secondary d-inline-flex align-items-center">{{app_currency.code}} {{ data.amount }}</span>
      </div>
    </div>
  </div>
</div>

<!-- Card 2: Client Details -->
<div class="card mb-3">
  <div class="card-header bg-light">
    <h6 class="card-title mb-0"><i class="ti ti-user me-2"></i>Client Details</h6>
  </div>
  <div class="card-body">
    <div class="row mb-2">
      <div class="col-4 fw-bold">Name</div>
      <div class="col-8">{{ data.name }}</div>
    </div>
    <div class="row mb-2">
      <div class="col-4 fw-bold">Email</div>
      <div class="col-8">{{ data.email }}</div>
    </div>
    <div class="row mb-2">
      <div class="col-4 fw-bold">Contact</div>
      <div class="col-8">{{ data.contact }}</div>
    </div>
    <div class="row">
      <div class="col-4 fw-bold">Payment Link</div>
      <div class="col-8">
        <a :href="data.short_url" target="_blank" rel="noopener" class="text-decoration-none me-1">{{ data.short_url }}</a>
        <a href="javascript:void(0);" @click="$copyText(data.short_url)"><i class="ti ti-copy"></i></a>
      </div>
    </div>
  </div>
</div>

<!-- Card 3: Description -->
<div class="card" v-if="data.description">
  <div class="card-header bg-light">
    <h6 class="card-title mb-0"><i class="ti ti-file-description me-2"></i>Description</h6>
  </div>
  <div class="card-body">
    <p v-html="data.description" style="max-height: 150px; overflow-y: auto;"></p>
  </div>
</div>

</div>
</div>
</div>
</div>
<!-- /View Details -->

<!-- Delete Modal -->
<div class="modal fade" id="payment_link_delete_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-body text-center">
  <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
    <i class="ti ti-trash-x fs-36"></i>
  </span>
  <h4 class="mb-1">Confirm Delete</h4>
  <p class="mb-3">
    You want to delete the item, this cant be undone once you delete.
  </p>
  <div class="d-flex justify-content-center">
    <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
    <a href="javascript:void(0);" class="btn btn-danger" @click="deletePaymentLink">Yes, Remove</a>
  </div>
</div>
</div>
</div>
</div>
<!-- /Delete Modal -->

</template>